import { render } from "./PieChart2.vue?vue&type=template&id=0877ecb6&scoped=true"
import script from "./PieChart2.vue?vue&type=script&lang=js"
export * from "./PieChart2.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0877ecb6"]])

export default __exports__